<template>
  <div class="container-fluid" id="container">
    <div class="row">
      <!-- <button @click="online">Click me</button> -->
      <!-- <side-bar :loggedIn="loggedIn"></side-bar> -->
      <!-- <div id="sidebar-closer"></div> -->
      <!-- <OfflineIndicator message="Oh no, you're offline, check your connection !"></OfflineIndicator> -->
      <navbar></navbar>
      <router-view :loggedIn="loggedIn"></router-view>
    </div>
    <div class="row">
      <!-- <contact-us v-if="$route.path === '/'"></contact-us> -->
      <footer-section class="hidden-xs"></footer-section>
    </div>
    <!-- <vue-loaders-css type="pacman"></vue-loaders-css> -->
  </div>
</template>

<script>
  import Vue from 'vue'
  // import SideBar from '@/components/SideBar'
  import PreLoader from '@/components/PreLoader'
  import Navbar from '@/components/Navbar.vue'
  import ContactUs from '@/components/ContactUs'
  import FooterSection from '@/components/FooterSection'
  // import { OfflineIndicator } from 'vue-online'
  import { default as VueScrollTo } from 'vue-scrollto'
  import VuePhoneNumberInput from 'vue-phone-number-input'
  import 'vue-phone-number-input/dist/vue-phone-number-input.css'
  // var VueScrollTo = require('vue-scrollto')
  // import VueLoadersCss from 'vue-loaders-css'
  // Vue.use(VueLoadersCss)
  // import {Snotify} from 'vue-snotify'
  // import {SnotifyService} from 'vue-snotify'
  // Vue.use(Snotify) // 2. Use Snotify

  Vue.component('vue-phone-number-input', VuePhoneNumberInput)

  Vue.use(VueScrollTo, {
    container: 'body',
    duration: 2000,
    easing: 'ease',
    offset: 0,
    cancelable: true,
    onDone: false,
    onCancel: false
  })

  export default {
    name: 'app',
    data () {
      return {
        loggedIn: false,
        authToken: null
      }
    },
    computed: {
      online () {
        // return VueOnline.isOnline
        // return
        // SnotifyService.success('Example title!', 'Example body content', {
        //   timeout: 2000,
        //   showProgressBar: false,
        //   closeOnClick: false,
        //   pauseOnHover: true
        // })
      }
    },
    mounted() {
      let token = localStorage.getItem('authToken')
      // console.log('Token', token)
      if (!token) return
      this.loggedIn = true
      this.authToken = token
    },
    components: {
      PreLoader,
      // SideBar,
      Navbar,
      ContactUs,
      // OfflineIndicator,
      // VueLoadersCss,
      FooterSection
    }
  }
</script>

<style>
div.offline-indicator {
  background: red;
  color: white;

    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 0 12px 0 50px;
    margin: 0;
    opacity: 1;
    transition-property: height,opacity,margin;
    transition-duration: .15s;
    transition-delay: .75s;
}
/* @import "~vue-snotify/styles/material.css"; */
</style>



// WEBPACK FOOTER //
// src/App.vue